import { render, staticRenderFns } from "./RecipientMenu.vue?vue&type=template&id=bfe857e8"
import script from "./RecipientMenu.vue?vue&type=script&lang=js"
export * from "./RecipientMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports